import React from "react";
import {
  PollRounded,
  QuestionMarkRounded,
  PeopleRounded,
  LocalActivity,
  StoreRounded,
  ManageAccountsRounded,
  GroupsRounded,
} from "@mui/icons-material";
import { AdminPermission } from "./auth.model";
import TranslateIcon from "@mui/icons-material/Translate";

export interface MenuItemModel {
  title: string;
  link: string;
  icon?: React.ReactElement;
  permissions?: AdminPermission[];
  onClick?: string;
  menuItems?: MenuItemModel[];
}

export interface MenuModel {
  title: string;
  menus: MenuItemModel[];
}

export function Dot() {
  return (
    <div className="all-center-wrapper" style={{ width: 24, height: 24 }}>
      <span className="circle dot"></span>
    </div>
  );
}

export const menus: MenuModel[] = [
  {
    title: "Accounts Management",
    menus: [
      {
        title: "admins",
        link: "/admins",
        permissions: [AdminPermission.admin_read],
        icon: <ManageAccountsRounded />,
      },
      {
        title: "Roles",
        link: "/roles",
        permissions: [AdminPermission.role_read],
        icon: <GroupsRounded />,
      },
      {
        title: "Company Data",
        link: "/company",
        menuItems: [
          {
            link: "/company-list",
            permissions: [AdminPermission.company_read],
            title: "companies",
            icon: <Dot />,
          },
          {
            link: "/company-stores",
            permissions: [AdminPermission.company_store_read],
            title: "Company Stores",
            icon: <Dot />,
          },
          {
            link: "/company-users",
            permissions: [AdminPermission.company_user_read],
            title: "Company Users",
            icon: <Dot />,
          },
        ],
        icon: <StoreRounded />,
      },
      {
        title: "customers",
        link: "/customers",
        permissions: [AdminPermission.customer_read],
        icon: <PeopleRounded />,
      },
    ],
  },
  {
    title: "Survey Management",
    menus: [
      {
        title: "surveys",
        link: "/survey-list",
        permissions: [AdminPermission.survey_read],
        icon: <PollRounded />,
      },
      {
        title: "Survey Events",
        link: "/survey-events",
        permissions: [AdminPermission.survey_event_read],
        icon: <LocalActivity />,
      },
      {
        title: "questions",
        link: "/survey-questions",
        permissions: [AdminPermission.question_read],
        icon: <QuestionMarkRounded />,
      },
    ],
  },
  {
    title: "Setting",
    menus: [
      {
        title: "Report Translation",
        link: "/report-translation",
        icon: <TranslateIcon />,
      },
    ],
  },
];
